import ForgotPasswordComponent from 'aa/vue/components/ForgotPassword';
import ForgotPasswordDefault from 'aa/vue/models/steps/ForgotPassword';
import { SIGNIN_URL } from 'aa/vue/constants/aaRoutes';

export default class ForgotPassword extends ForgotPasswordDefault {
    component = ForgotPasswordComponent;
    props = {
        cancelCallback: (e) => {
            window.location.href = SIGNIN_URL;
        }
    };
}
